import * as Types from '../types/graphql';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PredictHealthyLifeSpanQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PredictHealthyLifeSpanQuery = { __typename?: 'Query', predictHealthyLifeSpan: { __typename?: 'PredictHealthyLifeSpanPayload', result?: { __typename?: 'HealthyLifeSpan', isAdjusted: boolean, age: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, remaining: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, comparisonOfSameGeneration: { __typename?: 'HealthyLifeSpanComparison', isAverage: boolean, year: number, month: number } } | null, heart?: { __typename?: 'HealthyLifeSpan', isAdjusted: boolean, age: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, remaining: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, comparisonOfSameGeneration: { __typename?: 'HealthyLifeSpanComparison', isAverage: boolean, year: number, month: number } } | null, brain?: { __typename?: 'HealthyLifeSpan', isAdjusted: boolean, age: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, remaining: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, comparisonOfSameGeneration: { __typename?: 'HealthyLifeSpanComparison', isAverage: boolean, year: number, month: number } } | null, liver?: { __typename?: 'HealthyLifeSpan', isAdjusted: boolean, age: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, remaining: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, comparisonOfSameGeneration: { __typename?: 'HealthyLifeSpanComparison', isAverage: boolean, year: number, month: number } } | null, kidney?: { __typename?: 'HealthyLifeSpan', isAdjusted: boolean, age: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, remaining: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, comparisonOfSameGeneration: { __typename?: 'HealthyLifeSpanComparison', isAverage: boolean, year: number, month: number } } | null, lung?: { __typename?: 'HealthyLifeSpan', isAdjusted: boolean, age: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, remaining: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, comparisonOfSameGeneration: { __typename?: 'HealthyLifeSpanComparison', isAverage: boolean, year: number, month: number } } | null } };

export type HealthyLifeSpanFragment = { __typename?: 'HealthyLifeSpan', isAdjusted: boolean, age: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, remaining: { __typename?: 'HealthyLifeSpanTerm', year: number, month: number }, comparisonOfSameGeneration: { __typename?: 'HealthyLifeSpanComparison', isAverage: boolean, year: number, month: number } };

export type HealthyLifeSpanTermFragment = { __typename?: 'HealthyLifeSpanTerm', year: number, month: number };

export type HealthyLifeSpanComparisonFragment = { __typename?: 'HealthyLifeSpanComparison', isAverage: boolean, year: number, month: number };

export const HealthyLifeSpanTermFragmentDoc = gql`
    fragment healthyLifeSpanTerm on HealthyLifeSpanTerm {
  year
  month
}
    `;
export const HealthyLifeSpanComparisonFragmentDoc = gql`
    fragment healthyLifeSpanComparison on HealthyLifeSpanComparison {
  isAverage
  year
  month
}
    `;
export const HealthyLifeSpanFragmentDoc = gql`
    fragment healthyLifeSpan on HealthyLifeSpan {
  age {
    ...healthyLifeSpanTerm
  }
  remaining {
    ...healthyLifeSpanTerm
  }
  isAdjusted
  comparisonOfSameGeneration {
    ...healthyLifeSpanComparison
  }
}
    ${HealthyLifeSpanTermFragmentDoc}
${HealthyLifeSpanComparisonFragmentDoc}`;
export const PredictHealthyLifeSpanDocument = gql`
    query PredictHealthyLifeSpan {
  predictHealthyLifeSpan {
    result {
      ...healthyLifeSpan
    }
    heart {
      ...healthyLifeSpan
    }
    brain {
      ...healthyLifeSpan
    }
    liver {
      ...healthyLifeSpan
    }
    kidney {
      ...healthyLifeSpan
    }
    lung {
      ...healthyLifeSpan
    }
  }
}
    ${HealthyLifeSpanFragmentDoc}`;

export function usePredictHealthyLifeSpanQuery(options?: Omit<Urql.UseQueryArgs<PredictHealthyLifeSpanQueryVariables>, 'query'>) {
  return Urql.useQuery<PredictHealthyLifeSpanQuery, PredictHealthyLifeSpanQueryVariables>({ query: PredictHealthyLifeSpanDocument, ...options });
};